
import React, { Fragment, useEffect, useState, useRef } from 'react';
import axios from 'axios';
import moment from 'moment';
import '../../CSS/Table.css';
import { connect } from 'react-redux';
import { config } from '../../constant';

import { tableMock } from '../../../Mock/MockJson';
import localStorage from '../../../../../utils/localStorage';
import StyledTable from "../../../../../commons/styles/table";
import { ErrorComponent, NoRecordComponent } from '../../Utils';
import { Spin, Tag, Tooltip, Badge } from 'antd';
import { API_FILE, IPAddress } from '../../../../../commons/api';
import { tableTranslation } from '../../../Utils/Adapter/translationAdapter';
import { DownloadOutlined, BellFilled } from '@ant-design/icons';
import { getChartDataWithSelection, getChartDataWithoutSelection } from '../../ChartCalls';

const TableComponent = (props) => {
  const [columns, setColumns] = useState([]);
  const [tabledata, setTabledata] = useState([]);
  const [loading,] = useState(false);
  const [reportName, setReportName] = useState('');
  const [, setExtraKeys] = useState({ Type: 'Running' });
  const [errorInAPI, setErrorInAPI] = useState(false);
  const [noDataInDB, setNoDataInDB] = useState(false);
  let timeTicket = useRef(null);
  const requestCheck = useRef(true);
  const abortController = useRef(new window.AbortController());

  const {
    graphprops,
    selectionDate,
    selectionMonth,
    DeviceCode,
    selectionDateRange,
    dayMonthYear,
    currentTimeZone,
    translationCache
  } = props;

  useEffect(() => {
    if (timeTicket.current) {
      clearInterval(timeTicket.current);
    }
    let refreshTime = graphprops?.refreshTime ? graphprops.refreshTime * 60000 : config.defaultRefreshTime;
    timeTicket.current = setInterval(() => {
      if (requestCheck.current) {
        getData();
      }
    }, refreshTime);
    return () => {
      abortController.current.abort();
      clearInterval(timeTicket.current);
    };
  }, []);

  useEffect(() => {
    getData(props);
    // updateData();
  }, [
    selectionDate,
    selectionMonth,
    selectionDateRange,
    DeviceCode,
    dayMonthYear,
    props.translationCache
  ]);

  const updateData = async (data) => {
    try {
      const { graphprops } = props;
      const columnConfig = JSON.parse(graphprops[graphprops.graph].columns);
      const columnsList = [];

      if (columnConfig && Array.isArray(columnConfig)) {
        columnConfig.forEach((column) => {
          if (column.isUTC) {
            data = data.map((dataa) => {
              const date = moment.utc(dataa[column.key]).toDate();
              return {
                ...dataa,
                [column.key]: moment(date).local().format('YYYY-MM-DD HH:mm:ss')
              };
            });
          }
          columnsList.push({
            title: column.title,
            dataIndex: column.key,
            key: column.key,
            render: (text, record) => (
              <span style={{ color: record.Color }}>
                {column.showColor && record[`${column.key}_Color`] ? (
                  <Tag color={record[`${column.key}_Color`]} key={column.key}>
                    {text}
                  </Tag>
                ) : (
                  text
                )}
              </span>
            )
          });
        });
      }

      const reportPayload = data.map((dataObject) => {
        const newObj = {};
        columnsList.forEach((column) => {
          newObj[column.title] = dataObject[column.key] !== undefined ? dataObject[column.key] : '';
        });
        return newObj;
      });

      const reportName = await getReportNametoDownload(reportPayload);
      const translationTable = await tableTranslation(columnsList, translationCache, props.language);
      setColumns(translationTable);
      setTabledata(data);
      setReportName(reportName.file || '');
    } catch (e) {
      setColumns([]);
      setTabledata([]);
    }
  };

  const getReportNametoDownload = async (excelData) => {
    const { graphprops } = props;
    const payload = {
      Consumption: graphprops.title,
      Data: excelData || [],
      ...graphprops.excelObj,
      Name: graphprops.dashboardName,
      PortName: ' ',
      ReportType: 'singleHierarchy',
      Summary: [],
      SummaryReportType: 'singleHierarchy',
      SummaryType: 'false',
      WeeklySummary: [],
      SelectedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
      GeneratedDate: moment().format('YYYY-MM-DD HH:mm:ss')
    };
    const accessToken = localStorage.get('accessToken');
    const siteId = localStorage.get('currentSite');
    const options = {
      method: 'POST',
      url: `${API_FILE.GenerateExcel}?SiteId=${siteId}`,
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${accessToken}`
      },
      data: JSON.stringify(payload)
    };
    try {
      const { data } = await axios(options);
      return data;
    } catch {
      return '';
    }
  };

  const getData = async () => {

    requestCheck.current = false;
    setErrorInAPI(false);
    setNoDataInDB(false);
    let json = [];
    if (graphprops && graphprops.enableMock && graphprops.enableMock === true) {
      json = tableMock;
      requestCheck.current = true;
    } else {
      if (graphprops?.graph === 'rangeBar' && graphprops?.currentDateData !== undefined) {
        json = graphprops.currentDateData;
      } else {
        if (
          graphprops &&
          ((graphprops.DashboardLevelSelection === 'datePicker' ||
            graphprops.GraphLevelSelection === 'datePicker') &&
            selectionDate) ||
          (
            (graphprops.DashboardLevelSelection === 'monthPicker' ||
              graphprops.GraphLevelSelection === 'monthPicker') &&
            selectionMonth) ||
          (
            (graphprops.DashboardLevelSelection === 'dateRangePicker' ||
              graphprops.GraphLevelSelection === 'dateRangePicker') &&
            selectionDateRange) ||
          (
            (graphprops.DashboardLevelSelection === 'dateMonthYearPicker' ||
              graphprops.GraphLevelSelection === 'dateMonthYearPicker') &&
            dayMonthYear) ||
          (
            (graphprops.DashboardLevelSelection === 'deviceSelection' ||
              graphprops.GraphLevelSelection === 'deviceSelection') ||
            DeviceCode)
        ) {
          json = await getChartDataWithSelection({
            graphprops,
            selectionDate,
            selectionMonth,
            selectionDateRange,
            DeviceCode,
            dayMonthYear,
            abortController: abortController.current,
            currentTimeZone,
          });
          requestCheck.current = true;
        } else if (
          graphprops.GraphLevelSelection === 'none' ||
          graphprops.DashboardLevelSelection === 'none'
        ) {
          json = await getChartDataWithoutSelection({
            graphprops,
            abortController: abortController.current,
            DeviceCode,
            TimeZone: currentTimeZone,
          });
          requestCheck.current = true;
        }
      }
    }
    if ((json && json.message) || (Array.isArray(json) && json.length === 0 && !graphprops.enableMock)) {
      if (json.message) {
        setErrorInAPI(true);
      } else if (json.length === 0) {
        setNoDataInDB(true);
      }
    } else {
      updateData(json);
    }
    setErrorInAPI(errorInAPI);
    setNoDataInDB(noDataInDB);
  };
  let warningList = [{
    "name": "Warning-3 Low",
    "badgeColor": "rgb(176, 71, 71)"
  }, {
    "name": "Warning-3 High",
    "badgeColor": "rgb(168, 3, 3)"
  }, {
    "name": "Warning-2 Low",
    "badgeColor": "rgb(208, 151, 98)"
  },
  {
    "name": " Warning-2 High",
    "badgeColor": "rgb(176, 116, 5)"
  },
  {
    "name": " Warning-1 Low",
    "badgeColor": "rgb(137, 183, 185)"
  }, {
    "name": " Warning-1 High",
    "badgeColor": "rgb(3, 160, 168)"
  },
  ];
  return (
    <Fragment>
      <div>
        {reportName && (
          <a
            href={`${IPAddress.LOCAL}/api/reports/${reportName}`}
            style={{ fontWeight: 'bold' }}
          >
            <DownloadOutlined
              style={{ color: 'rgb(191, 191, 191)', float: 'right' }}
            />
          </a>
        )}
      </div>
      {noDataInDB || errorInAPI ? (
        noDataInDB ? (
          <NoRecordComponent />
        ) : (
          <ErrorComponent />
        )
      ) : (
        <span>
          {props.graphprops.title === 'Events Notifications & Alerts' && props.graphprops.dashboardName === 'Renewable Energy' && (
            <div style={{ display: 'flex', flexDirection: 'row-reverse' }}>
              <Tooltip title={'Running'}>
                <BellFilled
                  style={{ color: 'red', fontSize: '30px' }}
                  onClick={() => {
                    setExtraKeys({ Type: 'Running' });
                    getData({ Type: 'Running' });
                  }}
                />
              </Tooltip>
              <Tooltip title={'Stopped'}>
                <BellFilled
                  style={{ color: 'green', fontSize: '30px' }}
                  onClick={() => {
                    setExtraKeys({ Type: 'Stopped' });
                    getData({ Type: 'Stopped' });
                  }}
                />
              </Tooltip>
            </div>
          )}

          {loading === false && columns.length > 0 ? (
            <span>
              <div style={{ display: "flex" }}>
                {
                  props.graphprops.title === 'Alerts' && warningList && Array.isArray(warningList) && warningList.map((warn, index) => {
                    return <div key={index} style={{ display: 'flex', flexDirection: 'row-reverse' }}>
                      <div style={{ marginRight: '10px' }}>
                        - {warn.name}
                      </div>
                      <Badge color={warn.badgeColor} />
                    </div>;
                  })
                }
              </div>
              <StyledTable size="small"
                style={{ padding: '0px 10px', marginTop: '12px' }}
                columns={columns && Array.isArray(columns) ? columns : []}
                dataSource={tabledata && Array.isArray(tabledata) ? tabledata : []}
                scroll={{ y: 'auto', x: 200 }}
                pagination={tabledata.length <= (props.graphprops.table?.tableSize || 10) ? false : { pageSize: props.graphprops.table?.tableSize }}
              />
            </span>
          ) : (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <Spin spinning={loading} tip="Loading..." />
            </div>
          )}
        </span>
      )}
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  return {
    theme: state.ThemeReducer,
    translationCache: state.TranslationReducer.translationCache,
    currentTimeZone: state.LayoutReducer.currentTimeZone,
    language: state.TranslationReducer.currentLanguage
  };
};


export default connect(mapStateToProps)(TableComponent);